import React from 'react';
import { withRouter } from 'react-router-dom';
import * as Yup from 'yup';
import { connect } from 'react-redux';
import { Container, Col } from 'reactstrap';
import ShowContainer from '../../shared/components/show/ShowContainer';
import FormWrapper from '../../shared/components/form/FormWrapper';
import FormSectionWrapper from '../../shared/components/form/FormSectionWrapper';
import TextField from '../../shared/components/form/TextField';

const validationSchema = Yup.object().shape({
  id: Yup.number().required('Required'),
  trackingNumber: Yup.string().required('Required'),
});

const Form = () => (
  <Container>
    <ShowContainer>
      {
        ({ id, fulfillmentType }) => {
          if (!id || !fulfillmentType) return null;
          const initialValues = { id, trackingNumber: '' };
          const successResource = fulfillmentType === 'new_order' ? 'sales' : 'return';
          return (
            <FormWrapper
              initialValues={initialValues}
              validationSchema={validationSchema}
              formUrlSuffix={`/${id}/add_tracking`}
              formTitle="Add Tracking Form"
              formSubTitle={`Fill in relevant tracking info for Shipment #${id}`}
              successModalTitle="Shipment Tracking Added!"
              successModalMessage="You'll be sent back to the Shipments index page"
              submitButtonText="Add Tracking"
              successUrl={`/orders/${successResource}-shipments`}
            >
              <FormSectionWrapper>
                <Col md={6}>
                  <TextField
                    placeholder="Tracking Number..."
                    label="Tracking Number"
                    fieldName="trackingNumber"
                  />
                </Col>
              </FormSectionWrapper>
            </FormWrapper>
          );
        }
      }
    </ShowContainer>
  </Container>
);

export default withRouter(connect()(Form));
